const ROLE_NOTIFICATION_HEADER = 'Recibir notificaciones';
const ROLE_REQUEST_NOTIFICATION_HEADER = 'Notificar solicitudes de la sede';

const ROLE_NOTIFICATION_SETTINGS = Object.freeze([
  {
    header: ROLE_NOTIFICATION_HEADER,
    label: 'Solicitud ejecutada',
    description: 'Envía un correo solo al solicitante cuando un administrador marca su solicitud como ejecutada.',
  },
  {
    header: ROLE_REQUEST_NOTIFICATION_HEADER,
    label: 'Solicitudes en mi sede',
    description: 'Al pulsar TERMINAR Y ENVIAR, envía a los usuarios con este rol un resumen de las solicitudes pendientes de sus sedes asignadas.',
  },
]);

function getRoleNotificationSetting(header) {
  const normalizedHeader = String(header || '').trim().toLocaleLowerCase();
  return ROLE_NOTIFICATION_SETTINGS.find((setting) => setting.header.toLocaleLowerCase() === normalizedHeader);
}

module.exports = {
  ROLE_NOTIFICATION_HEADER,
  ROLE_REQUEST_NOTIFICATION_HEADER,
  ROLE_NOTIFICATION_SETTINGS,
  getRoleNotificationSetting,
};
